import { ENDPOINTS } from '../consts/endpoints';
import { AbstractApi } from '../../abstract-api';
import { UserType, DEFAULT_PARAMS } from '../../user-api';
import {
  QuizSessionHistory,
  PatchQuizSessionParams,
  QuizSessionResetParams,
  QuizSessionProfileParams,
  PatchQuizSessionResponse,
  QuizSessionProfileResponse,
  QuizSession as QuizSessionType,
} from '../types';

export class QuizSessionApi extends AbstractApi {
  async getQuizSession(
    userType?: UserType,
    department?: string,
    roleDepartmentId?: string
  ): Promise<QuizSessionType> {
    const axios = await this.axios();
    const params = {
      type: userType ?? DEFAULT_PARAMS.USER_TYPE,
      department: department ?? DEFAULT_PARAMS.DEPARTMENT,
      roleDepartmentId: roleDepartmentId ?? DEFAULT_PARAMS.ROLE_DEPARTMENT_ID,
    };

    const { data } = await axios.get<QuizSessionType>(ENDPOINTS.LEARNING.QUIZ_SESSION.BASE, {
      params,
    });
    return data;
  }

  async getHistory(): Promise<QuizSessionType[]> {
    const axios = await this.axios();
    const { data } = await axios.get<QuizSessionHistory>(ENDPOINTS.LEARNING.QUIZ_SESSION.HISTORY);
    return data;
  }

  async patchQuizSession(
    paramsData: PatchQuizSessionParams,
    userType?: UserType,
    department?: string,
    roleDepartmentId?: string
  ): Promise<QuizSessionType> {
    const axios = await this.axios();
    const params = {
      type: userType ?? DEFAULT_PARAMS.USER_TYPE,
      department: department ?? DEFAULT_PARAMS.DEPARTMENT,
      roleDepartmentId: roleDepartmentId ?? DEFAULT_PARAMS.ROLE_DEPARTMENT_ID,
    };
    const { data } = await axios.patch<PatchQuizSessionResponse>(
      ENDPOINTS.LEARNING.QUIZ_SESSION.BASE,
      { ...paramsData },
      { params }
    );
    return data.session;
  }

  async putQuizSessionProfile(
    profile: string,
    userType?: UserType,
    department?: string
  ): Promise<QuizSessionProfileResponse> {
    const axios = await this.axios();
    const reqBody: QuizSessionProfileParams = {
      profile,
    };
    const params = {
      type: userType ?? DEFAULT_PARAMS.USER_TYPE,
      department: department ?? DEFAULT_PARAMS.DEPARTMENT,
    };
    const { data } = await axios.put<QuizSessionProfileResponse>(
      ENDPOINTS.LEARNING.QUIZ_SESSION.PROFILE,
      { ...reqBody },
      { params }
    );
    return data;
  }

  async putQuizSessionReset(
    userType?: UserType,
    department?: string,
    roleDepartmentId?: string
  ): Promise<QuizSessionType> {
    const axios = await this.axios();
    const params: QuizSessionResetParams = {
      type: userType ?? DEFAULT_PARAMS.USER_TYPE,
      department: department ?? DEFAULT_PARAMS.DEPARTMENT,
      roleDepartmentId: roleDepartmentId ?? DEFAULT_PARAMS.ROLE_DEPARTMENT_ID,
    };
    const { data } = await axios.put<QuizSessionType>(ENDPOINTS.LEARNING.QUIZ_SESSION.RESET, null, {
      params,
    });
    return data;
  }
}
